var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripe = function SvgStripe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stripe_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 638 244.51",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Stripe_svg__cls-1,.Stripe_svg__cls-2{fill:#c70707}.Stripe_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Stripe_svg__cls-1",
    d: "m319.24 114.73 102.81 129.71h65.94L487.98 0h-73.45v121.12L319.24 0h-73.91v244.44h73.91V114.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Stripe_svg__cls-1",
    d: "m181 622.12 100.76.14 28.74-.08c20.59 0 39.63-3.13 57-13.27 38.85-22.62 42.21-72.37 14-99.07-15-13.21-24.88-15.29-31.76-17.37 9.55-4.75 18.54-11.09 25.45-19.3s11.28-20.34 10.82-34.38c-1.66-50.46-46.09-61.05-81.27-61.05h-35.03L181 378Zm75.57-188H285c15.2 0 26.16 4.27 25.75 20-.31 13.65-12.2 18.88-25.75 18.88h-28.43Zm0 93.33h38.93c17.51 0 29.33 6.38 28.94 19.73-.38 12.75-10.72 18.64-24.61 18.64h-43.28Z",
    transform: "translate(-181 -377.74)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Stripe_svg__cls-1",
    d: "m594.68 29.07-75.09 74.31v141.06h75.09V29.07zM519.59 74.74 594.68 0h-75.09v74.74z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Stripe_svg__cls-2",
    d: "M813.3 600a11.56 11.56 0 1 0 3.39 8.18 11.52 11.52 0 0 0-3.39-8.18m-8.17-5.7a13.88 13.88 0 1 1-9.82 4.07 13.84 13.84 0 0 1 9.82-4.05Z",
    transform: "translate(-181 -377.74)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Stripe_svg__cls-2",
    d: "M801.78 602.69h2.92c2 0 4.21.32 4.21 2.49 0 2.49-3 2.49-5.28 2.49h-1.85Zm-2.07 13.4h2.07v-6.76h2.67l4.74 6.76h2.54l-5-6.93c2.71-.37 4.37-1.79 4.37-4 0-3.73-3.58-4.15-7-4.15h-4.47Z",
    transform: "translate(-181 -377.74)"
  })));
};
export default SvgStripe;